module.exports = __webpack_public_path__ + "static/blue-mount-e599eccd9de1c9dc7aa8813d40703260.jpg";